import React from "react";
import Login from "../../Login";
import { useEffect } from "react";
import { setCookie } from "../../../helpers";
import { useSelector, useDispatch } from "react-redux";
import { ImgIcon } from "../../../assets";
import { logout } from "../../../actions/session";
import { Link } from "react-router-dom";

export default function LoginSection({ slug, onChange, values }) {

	const dispatch = useDispatch();
	const { user } = useSelector(state => state.session);

	useEffect(() => {
		setCookie({
			key: "redirect_to",
			value: `/signup/${slug}`
		});
	}, [slug]);

	useEffect(() => {
		if ((values.userData ? values.userData.email : null) !== (user ? user.email : null))
			onChange({ userData: user ? { email: user.email, shop: user.shop } : null });
	}, [user, values.userData, onChange]);

	// If we're already logged in, present the current user and ask if they want to
	// continue as them.
	if (user) return <div className="loginSection">
		{user.shop ? <div className="details">
			Hi <b>{user.email}</b>. You're already logged in, and already have a shop, whch is awesome! Unfortunately you can only have one for now. Feel free to log out and create another account if you want to!
			<br /><br />
			If you just wanted to go to your account, <Link to="/me">click here</Link>.
		</div> : <div className="details">
				You're logged in as the user below. If you want to continue as <b>{user.email}</b> just press next, otherwise log out and connect with a different account.
				<br /><br />
				If you just wanted to go to your account and weren't trying to set up a shop, <Link to="/me">click here</Link>.
		</div>}
		<div className="userSummary">
			<div className="inner">
				{Boolean(user.firstName || user.lastName) && <div className="name" title={`${user.firstName} ${user.lastName}`}>
					{user.firstName} {user.lastName}
				</div>}
				<div className="email" title={user.email}>
					{user.email}
				</div>
				<div className="userImage">
					<ImgIcon
						src={user.picture}
						size={60}
					/>
				</div>
			</div>
			<button className="logout" onClick={e => dispatch(logout())}>
				Log out
			</button>
		</div>
		<br />
	</div>

	return <div className="loginSection">
		<div className="details">
			Continue with Facebook or Google to log in or set up an account instantly, or use your email address.
			<br /><br />
			We recommend using social because you won't have to validate your email!
		</div>
		<Login />
		<br /><br />
	</div>
}